import http from './http'
import configJson from "./webhisconfig.json"
const base_url = configJson.base_url

//不管是get请求还是post请求,加密后都是post请求

//登录
export function post_save_login(account, password) {
  return http.post(`${base_url}/pyx_kfpt/auth/login`, 'save_login', {
    account: account,
    password: password
  })
}

export function alter_user_password(userAccount, oldPassword, newPassword) {
  return http.post(`${base_url}/pyx_kfpt/hospital/alter_user_password`, 'alter_user_password', {
    userAccount: userAccount,
    oldPassword: oldPassword,
    password: newPassword,
  })
}
export function gly_reset_user_password(userAccount) {
  return http.post(`${base_url}/pyx_kfpt/hospital/gly_reset_user_password`, 'gly_reset_user_password', {
    userAccount: userAccount
  })
}
export function delete_user_by_account(userAccount) {
  return http.post(`${base_url}/pyx_kfpt/hospital/delete_user_by_account`, 'delete_user_by_account', {
    userAccount: userAccount
  })
}

//获取用户/医院基本信息
export function get_u_a_h_list() {
  return http.get(`${base_url}/pyx_kfpt/hospital/get_u_a_h_list`, 'get_u_a_h_list', {})
}
export function get_hospital_list(queryItem) {
  return http.post(`${base_url}/pyx_kfpt/hospital/get_hospital_list`, 'get_hospital_list', queryItem)
}
export function get_yy_user_list(queryItem) {
  return http.post(`${base_url}/pyx_kfpt/hospital/get_yy_user_list`, 'get_yy_user_list', queryItem)
}
export function get_gs_user_list(queryItem) {
  return http.post(`${base_url}/pyx_kfpt/hospital/get_gs_user_list`, 'get_gs_user_list', queryItem)
}

export function get_dict_list() {
  return http.get(`${base_url}/pyx_kfpt/hospital/get_dict_list`, 'get_dict_list', {})
}

//医院问题获取
export function get_hospital_question_list(queryItem) {
  return http.post(`${base_url}/pyx_kfpt/hospital/get_question_list`, 'get_hospital_question_list', queryItem)
}

export function save_hospital_question(qusetion) {
  return http.post(`${base_url}/pyx_kfpt/hospital/save_question`, 'save_question', qusetion)
}
export function save_question_send_back(qusetion) {
  return http.post(`${base_url}/pyx_kfpt/hospital/save_question_send_back`, 'save_question_send_back', qusetion)
}
export function update_question(qusetion) {
  return http.post(`${base_url}/pyx_kfpt/hospital/update_question`, 'update_question', qusetion)
}

export function save_user(user) {
  return http.post(`${base_url}/pyx_kfpt/basic/save_user`, 'save_user', user)
}

export function update_user(user) {
  return http.post(`${base_url}/pyx_kfpt/basic/update_user`, 'update_user', user)
}

export function save_hospital(hospital) {
  return http.post(`${base_url}/pyx_kfpt/basic/save_hospital`, 'save_hospital', hospital)
}

export function update_hospital(hospital) {
  return http.post(`${base_url}/pyx_kfpt/basic/update_hospital`, 'update_hospital', hospital)
}

export function get_contract_expiration_warn(queryItem) {
  return http.post(`${base_url}/pyx_kfpt/basic/get_contract_expiration_warn`, 'get_contract_expiration_warn', queryItem)
}


export function get_weixin_qrcode() {
  return http.get(`${base_url}/pyx_kfpt/get_weixin_qrcode`, 'get_weixin_qrcode', {})
}

export function user_apply(userApply) {
  return http.post(`${base_url}/pyx_kfpt/user_apply`, 'user_apply', userApply)

}

export function get_user_apply() {
  return http.post(`${base_url}/pyx_kfpt/get_user_apply`, 'get_user_apply', {})
}

export function update_user_apply(userApply) {
  return http.post(`${base_url}/pyx_kfpt/update_user_apply`, 'update_user_apply', userApply)
}

export function get_user_by_openid(queryItem) {
  return http.post(`${base_url}/pyx_kfpt/get_user_by_openid`, 'get_user_by_openid', queryItem)
}


export function get_user_question_level(queryItem) {
  return http.post(`${base_url}/pyx_kfpt/cxtj/get_user_question_level`, 'get_user_question_level', queryItem)
}

export function get_user_unfinished_question(queryItem){
    return http.post(`${base_url}/pyx_kfpt/cxtj/get_user_unfinished_question`, 'get_user_unfinished_question', queryItem)
}


export function get_hospital_type() {
  return http.post(`${base_url}/pyx_kfpt/get_hospital_type`, 'get_hospital_type', {})
}

export function get_question_level() {
  return http.post(`${base_url}/pyx_kfpt/get_question_level`, 'get_question_level', {})
}

export function get_question_dispose() {
  return http.post(`${base_url}/pyx_kfpt/get_question_dispose`, 'get_question_dispose', {})
}